import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { HeaderCell, IconUp, IconDown, IconWrapper } from './styles';

const SortedTableHeaderCell = ({ onHeaderClick, name, column, direction }) => {
  const { formatMessage } = useIntl();

  const handleClick = () => {
    onHeaderClick({ column, name, direction });
  };

  return (
    <HeaderCell
      type="button"
      data-column={column}
      data-sort={direction}
      onClick={handleClick}
    >
      {formatMessage({
        id: `tableHeader.${name}`,
      })}

      <IconWrapper>
        <IconUp />
        <IconDown />
      </IconWrapper>
    </HeaderCell>
  );
};

SortedTableHeaderCell.propTypes = {
  direction: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  column: PropTypes.string,
  onHeaderClick: PropTypes.func.isRequired,
};

SortedTableHeaderCell.defaultProps = {
  column: null,
};

export default SortedTableHeaderCell;
